import Component from './Component';
import { hasError, showError, removeError, handleEvents } from './../services/FormValidation';
import axios from 'axios';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

  let newPromise;


/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Subscription extends Component {

    decorator () {
        return {
            selector : '.js-subscription',
            name : 'Subscription',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        this.bindElements();
    }


    cacheElements () {
        this.$form = this.element.getElementsByTagName('form');
        this.$formElements = this.$form[0].elements;
        this._token = this.$formElements['_token'];
        this._action = this.$form[0].getAttribute('action');
    }

    bindElements () {

        this.$form[0].addEventListener('submit', e => {
            e.preventDefault();

            const fields = e.target.elements;
            let error,
                hasErrors;

            for (let i = 0; i < fields.length; i++) {
                error = hasError(fields[i]);

                if (error) {
                    showError(this.$formElements, fields[i], error);

                    if (!hasErrors) {
                        hasErrors = fields[i];
                    }
                }

                if (hasErrors) {
                    hasErrors.focus();
                }
            }

            if (typeof hasErrors != 'undefined') { return; }

            this.disableForm();

            this.sendDataTo(this._action, this._token.value);
        });


        handleEvents(this.$formElements);

    }

    sendDataTo (url, token) {

        newPromise = axios.post(url, {
                '_token': token,
                'email_address' : this.$formElements['newsletter_email_address'].value
            })
            .then(response => {
                if (response.status == 200) {
                    const data = response.data;

                    if (data.success) {
                        this.$form[0].innerHTML = this.renderMessage(data.message);
                    }
                }
            })
            .catch(error => {
                this.enableForm();
                console.error(error);
            });

    }

    renderMessage (message) {
        let template = `
            <div class="message">
                <p>${message}</p><!-- /.o-article-item__content -->
            </div><!-- /.o-article-item -->
        `;
        return template;
    }

    disableForm () {
        this.$formElements['newsletter_email_address'].setAttribute('disabled', '');
        this.$formElements['newsletter_submit'].setAttribute('disabled', '');
    }

    enableForm () {
        this.$formElements['newsletter_email_address'].removeAttribute('disabled');
        this.$formElements['newsletter_submit'].removeAttribute('disabled');
    }



}
